import React from 'react';

import { Button } from '@gogame/components';
import { withArrayFormField, useFormContext } from '@gogame/form';
import { useChildComponent } from '@gogame/hooks-ts';

import {
  OwnersManagement,
  OWNERS,
} from 'scenes/Campaigns/GGCampaigns/components/OwnersManagement';
import { OWNER } from 'scenes/Campaigns/components/Form/constants';

export const Owners = withArrayFormField()(({ name, value, form }) => {
  const { values } = useFormContext();
  const [childComponent, openChildComponent] = useChildComponent();
  const handleChangeOwner = () => {
    openChildComponent(OwnersManagement, {
      initialValues: {
        [OWNERS]: value,
        [OWNER]: values[OWNER],
      },
      onSubmit: ({ [OWNERS]: owners }) => {
        form.setFieldValue(name, owners);
      },
    });
  };

  return (
    <React.Fragment>
      {childComponent}
      <Button onClick={handleChangeOwner}>Manage Owners</Button>
    </React.Fragment>
  );
});
